import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

//import ExtensionHome from './extension/ExtensionHome';
import UpdateHome from './update/UpdateHome';
import ComingSoon from './ComingSoon';


import AdminHome from './admin/AdminHome';
import Sites from './admin/sites/Sites';
import SiteAdd from './admin/sites/SiteAdd';
import SiteView from './admin/sites/SiteView';
import SiteEdit from './admin/sites/SiteEdit';

import TestAddress from './update/TestAddress';
import TestLogin from './update/TestLogin';
import TestHome from './update/TestHome';





function App() {
  
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route exact path="/" element={ <ComingSoon/>} />
          <Route path="/update" element={< UpdateHome/>} />
          <Route path="/update/:siteId" element={< UpdateHome/>} />
          <Route path="/test" element={< TestHome/>} />
          <Route path="/test/address" element={< TestAddress/>} />
          <Route path="/test/login" element={< TestLogin/>} />


          <Route path="/admin" element={< AdminHome/>} />
          <Route path="/admin/sites" element={< Sites/>} />
          <Route path="/admin/sites/new" element={< SiteAdd/>} />
          <Route path="/admin/sites/:siteId/view" element={< SiteView/>} />
          <Route path="/admin/sites/:siteId/edit" element={< SiteEdit/>} />

        </Routes>
      </Router>
    </div>
  );
}

export default App;



// used to have this in package.json
//"proxy": "https://us-central1-address-plant.cloudfunctions.net/api",
  
